export default __webpack_public_path__ + "static/media/ar.eac3e4fd.svg";